// @index(d:!): export { default as ${variable}} from ${relpath}
export { default as ImportDialog } from './ImportDialog'
// /index

// @index(d:!): export type {Props as ${variable}Props} from ${relpath}
export type {Props as ImportDialogProps } from './ImportDialog'
// /index